import { combineReducers } from "redux";
import session from "./session";
import admins from "./admins";
import serverTypeReducer from './server'

export default combineReducers({
    session,
    admins,
    server: serverTypeReducer,
});
